import React from 'react';
import './_service_id.scss';
import './_service_id.dark-mode.scss';
import PropTypes from 'prop-types';

const ServiceId = ({ children }) => (
  <span className="badge-service-id">
    {children}
  </span>
);

ServiceId.propTypes = {
  children: PropTypes.node,
};
export default ServiceId;
